import { AdminMultimediaGridFilter } from './admin-multimedia-grid-filter';
import { Nillable } from '@web/utils';

export class AdminMultimediaGridChunkLazyLoad {
  public constructor(
    public readonly part: number,
    public readonly size: number,
    public readonly filter?: Nillable<AdminMultimediaGridFilter>,
  ) {}
}
